<!--
 * @Author: your name
 * @Date: 2020-08-13 20:04:19
 * @LastEditTime: 2022-12-07 15:12:29
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/pay/index.vue
-->
<style scoped lang="sass">
$color1: rgba(20, 196, 188, 1)
$color2: rgba(51, 68, 85, 1)
$color3: #f1f2f3
$color4: rgba(51, 68, 85, 0.75)

.indent_padding
  padding-left: 17px
  padding-right: 17px

.left_footer
  display: flex
  justify-content: center
  align-items: center
  width: 100%
  height: 100%
  color: var(--menu-primary-background-colour) !important
  font-size: 14px
  font-weight: 500
  line-height: 18px

.pay
  .content
    padding-bottom: 75px

    .order
      margin: 30px 0

    .item
      margin-top: 45px
      line-height: 16px
      font-size: 16px
      font-weight: 500
      color: var(--menu-primary-background-colour) !important

    .pickup_box
      display: flex
      flex-direction: column
      margin-top: 16px
      background: rgba(50, 56, 62, 0.02)
      color: var(--menu-primary-background-colour)
      border-top: 1px solid #EBEBEC
      border-bottom: 1px solid #EBEBEC

      .item_box
        display: flex
        flex-direction: column
        align-items: center
        margin-top: 17px
        text-align: center

        &:last-child
          margin-top: 7px

        .item
          margin-top: 0

    .item_text
      margin-top: 7px
      margin-bottom: 14px
      padding: 0 17px
      text-align: center
      font-size: 14px
      line-height: 14px
      color: var(--menu-primary-text-colour) !important

    .order_total
      flex-shrink: 0
      display: flex
      justify-content: space-between
      align-items: center
      height: 20px
      line-height: 20px
      margin-top: -5px
      margin-bottom: 30px
      @extend .indent_padding
      // border-bottom: 1px solid $color3
      &.ngap
        margin-bottom: 2px

      .text,
      .price
        color: var(--menu-primary-text-colour) !important
        font-size: 12px
        line-height: 20px

.msg
  display: flex
  flex-direction: column
  align-items: center
  margin-top: 25px

  .title
    width: 250PX

  .info
    font-size: 10px
    line-height: 10px
    color: $color4

    .title
      margin-bottom: 15px
      font-size: 19px
      font-weight: 500
      line-height: 19px
      color: var(--menu-primary-background-colour) !important
      text-align: center

    .note
      font-size: 10px
      line-height: 10px
      color: var(--menu-primary-text-colour) !important

::v-deep

  .van-button--primary
    background-color: var(--menu-primary-background-colour) !important

  .disabled
    background-color: #ddd !important

::v-deep
  .van-popup
    border-radius: 18PX 18PX 0 0
</style>

<style lang="sass" scoped>
.sub_total
  display: flex
  flex-direction: column
  padding: 5px 0

  .sub_total_item
    display: flex
    justify-content: space-between
    align-items: center
    font-size: 12px
    line-height: 20px
    color: var(--menu-primary-text-colour) !important
    padding-left: 17px
    padding-right: 17px

.num
  margin-bottom: 27px

  ::v-deep
    .order_number
      width: 100%
      border-color: #33445533
      .order_status
        margin-top: 15px
        .van-button
          border-radius: 4px !important
          border-color:  var(--menu-primary-background-colour)
          font-weight: bold
          font-size: 13px

.multi_store_note
  margin-top: -18px
  margin-bottom: 12px
  text-align: center
  font: normal normal normal 12px/16px Roboto
  letter-spacing: 0px
  color: var(--menu-primary-text-colour)

.footer_bar
  position: fixed
  bottom: 0

.order_post_paid
  position: relative

  .title
    border: 2px solid var(--menu-primary-background-colour) !important
    height: 50px
    width: 50px
    border-radius: 50%
    opacity: .2

  .note
    position: absolute
    top: 50%
    left: 50%
    transform: translate3d(-50%, -50%, 0)
    color: var(--menu-primary-background-colour) !important

.header
  font-size: 26px
  line-height: 31px
  margin-bottom: 8px
  margin-top: 12px
  color: var(--menu-primary-background-colour) !important

.subtitle
  padding: 0 45px 25px 45px
  text-align: center
  font-size: 14px
  line-height: 16px
  color: var(--menu-primary-text-colour) !important

.process
  padding-left: 17px
  padding-right: 17px

.min_delivery_amount
  display: flex
  align-items: center
  margin: 0 14px 14px
  padding: 0 10px
  height: 46px
  background: rgba(176, 6, 32, .1)
  border: 1px solid rgba(176, 6, 32, .3)
  border-radius: 4px

  .min_delivery_amount_icon
    font-size: 26px
    color: #B00620 !important

  .min_delivery_amount_text
    margin-left: 8px
    font-size: 12px
    list-style: 46px
    color: rgba(0, 0, 0, .75)

.order_item_box
  margin-top: 21px
  padding-left: 17px
  line-height: 16px
  font-size: 16px
  font-weight: bold
  color: var(--menu-primary-background-colour)

  .box
    margin-bottom: 8px

.order_item_collapse
  margin-bottom: 20PX
  font-size: 14PX
  font-weight: bold
  background-color: #32383E0D

  .collect_content
    background: #FFFFFF 0% 0% no-repeat padding-box
    border: 1px solid #32383E19
    border-radius: 4px
    padding: 10PX 10PX

    .venue_title
      font-size: 15PX
      font-weight: bold
      color: #000000

    .display_content
      font-size: 12PX
      color: #334455

  ::v-deep
    .title
      color: var(--menu-primary-background-colour)

    .van-cell
      padding-top: 0
      padding-bottom: 0
      height: 50PX

    .van-collapse-item__content
      background-color: #32383E0D

.order_item_section
  width: 100%

  .venue_title
    height: 34PX
    background: #32383E0D 0% 0% no-repeat padding-box
    display: flex
    justify-content: space-between
    align-items: center

    .name
      font-size: 15px
      font-weight: bold
      margin-left: 16PX

  .store_order_no
    text-align: left
    margin: 10px 16PX
    font: normal normal bold 13px/18px Roboto
    letter-spacing: 0px
    color: var(--menu-primary-background-colour)

.order_information
  padding: 30px 16px 0 16px
  font-size: 13px
  line-height: 18px

  .information_title
    font-weight: bold

.box
  color: var(--menu-primary-background-colour)

.alcohol
  padding: 12px 13px
  margin: 10px 17px 0 17px
  background: rgba(var(--menu-primary-background-colour-rgb), .08)
  border: 1px solid var(--menu-primary-background-colour)
  border-radius: 4px

  .text
    font-size: 14px
    color: var(--menu-primary-text-colour)
</style>

<template lang="pug">
  .pay
    .content.overflow_scroll(v-if="order.id")
      .msg.ns
        .info(v-if="isPostPaid && routerName === 'pay'")
          .title {{ t('thank_you_for_order', 'Thank you for your order!') }}
          .note.o {{ t('pay_when_served', 'You can pay for your meal once everything has been served.') }}
        .order_post_paid(v-if="(isPostPaid && routerName === 'my-order') || isTabPay || showOnlineInfo")
          .title
          icon.note(size='35') check
        .header.b.ls1(v-if="(isPostPaid && routerName === 'my-order' && !isCounterPay) || isTabPay || showOnlineInfo") {{ t('order_confirmed', 'Order confirmed') }}
        .subtitle(v-if="isPostPaid && routerName === 'my-order' && !isCounterPay || showOnlineInfo")
          | {{ t('receipt_sent', 'A receipt has been sent to your email.') }}
          div(v-if="order.details.orderType === 'delivery' && (order.details.deliveryInfo && order.details.deliveryInfo.deliveryPartner !== 'local')") {{ t('delivery_tracking_link', "When your order is on its way, we'll send you a link to track the delivery.") }}

        .header.b.ls1(v-if="isPostPaid && routerName === 'my-order' && isCounterPay") {{ t('thank_you', 'Thank you') }}
        .subtitle.o5(v-if="isPostPaid && routerName === 'my-order' && isCounterPay") {{ t('pay_at_counter', 'Please pay at the counter when you finish.') }}
        .title(v-if="!isPostPaid && !isTabPay && !showOnlineInfo")
          Num.num(:createdAt="order.createdAtString" :orderNo="order.orderNo" :orderStatusUrl="orderStatusUrl")
          .multi_store_note(v-if="hasStoreNumbers") {{ t('show_each_store_note', 'Show each store its own number when you collect.') }}

      .pickup_box(v-if="isOnline")
        .item_box
          .item {{ order.details.orderType === 'pickup' ? t('pickup_from', 'Pickup from') : t('delivering_to', 'Delivering to') }}:
          .item_text {{ order.details.orderType === 'pickup' ? venueAddress : order.details.userInfo.address.fullAddress }}
        .item_box
          .item {{ order.details.orderType === 'pickup' ? t('pickup_time', 'Pickup time') : t('estimated_delivery_time', 'Estimated delivery time') }}:
          .item_text {{ preOrderTimeSettings }}

      .alcohol(v-if="!isFromOrderHistoryToOrderDetail && alcoholText" :class="{ mt20: isOnline }")
        .text {{ alcoholText }}

      collapse.order_item_collapse(
        :title="t('how_to_collect', 'HOW TO COLLECT MY ORDER')"
        :name="t('how_to_collect', 'HOW TO COLLECT MY ORDER')"
        :id="order.id"
        :index="tempCollapseIndex"
        @change="tempCollapseIndex = $event"
      )
        .collect_content(v-if="order.generalMessage && hasRichContent(order.generalMessage.message)")
          .venue_title {{ order.generalMessage.name }}
          .display_content(v-html="renderRichText(order.generalMessage.message)")

        .collect_content(
          v-for="(venueOrders, venueIdIndex) in order.itemList"
          v-if="hasRichContent(getOrderCollectionInfo(venueIdIndex))"
        )
          .venue_title {{ venueOrders.venue.name }}
          .display_content(v-html="renderRichText(getOrderCollectionInfo(venueIdIndex))")

      .order_item_section(
        v-for="(venueOrders, venueIdIndex) in order.itemList"
      )
        .venue_title
          .name {{ venueOrders.venue.name }}
        .store_order_no(v-if="hasStoreNumbers && storeNo(venueIdIndex)") {{ t('store_order_number', 'Order number') }} {{ '#' }}{{ storeNo(venueIdIndex) }}
        .min_delivery_amount(v-if="checkPosStatus(venueIdIndex)")
          icon.min_delivery_amount_icon announcement
          .min_delivery_amount_text {{ errorOrderText }}

        Items(
          v-for="item in venueOrders.itemList"
          :key="item.id"
          :data="item"
          :isPostPaid="isPostPaid"
        )
      .sub_total.ns
        .sub_total_item
          div {{ t('subtotal', 'Subtotal:') }}
          div {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ order.subtotal | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
        .sub_total_item(v-if="showDiscounts")
          div {{ t('discount', 'Discount') }}
            span(v-if="isRateDiscount") {{ ` (${ discountRate }%)` }}
            span {{ ` ${order.details.discounts.name}:` }}
          div {{ symbolPosition === 'after' ? '-' : '-' + currencySymbol }}{{ (order.id ? order.details.discounts.amount : 0) | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
        .sub_total_item(v-if="discountAmount")
          div {{ t('discount', 'Discount:') }}
          div {{ symbolPosition === 'after' ? '-' : '-' + currencySymbol }}{{ discountAmount | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
        .sub_total_item(v-if="order.details.surchargeAmount")
          div {{surchargeHead}}:
          div {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ order.details.surchargeAmount | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
        .sub_total_item(v-if="isOnline && order.details.orderType === 'delivery'")
          div {{ t('delivery_fee', 'Delivery fee:') }}
          div {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ order.details.baseFee | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
        .sub_total_item(v-if="customerMerchantFee !== 0")
          div {{ t('payment_surcharge', 'Venue Surcharge') }}:
          div {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ (order.id ? order.details.customerMerchantFee : 0) | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
        .sub_total_item(v-if="showTipping")
          div {{ t('tip_amount', 'Tip Amount:') }}
          // @todo wrong field position
          div {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ (order.id ? order.tipAmount : 0) | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
      .order_total.ngap(v-if="order.refundAmount > 0")
        .text.b {{ t('total_refund', 'Total refund:') }}
        .price.b {{ symbolPosition === 'after' ? '-' : '-' + currencySymbol }}{{ order.refundAmount | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
      .order_total.ns
        .text.b {{ t('total_amount_paid', 'Total amount paid:') }}
        .price.b {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ order.amount | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
      down-load-tax(
        v-if="((routerName === 'venue-sub-group-my-order' && !isTabPay) && order.amount > 0) || isOnline"
        :is-counter-pay="isCounterPay"
        :orderId="orderId"
        :isSubGroup="true"
        :isPostPaid="isPostPaid"
        :email="getOrderEmail"
        :name="order.orderNo"
        :isOnline="isOnline"
      )
      .order_information(v-if="email || phone")
        .information_title {{ t('questions_about_order', 'Questions about your order?') }}
        .information_call(v-if="phone") Call: {{ phone }}
        .information_call(v-if="email") Email: {{ email }}

    footer-bar.footer_bar(
      v-if="routerName === 'pay' && order.paymentStatus !== 1"
      :isButton="true"
      :disabled="(order.id ? order.status < 40 : true) || isCounterPay"
      @clickButton="jumpToPayment"
    )
      template(v-slot:left)
        .left_footer(@click="jumpToIndex") {{ orderMoreText }}

    footer-common.footer_bar(
      v-if="(isOnline && routerName === 'pay') || (routerName !== 'pay' && isCounterPay)"
      :text="counterOrderText"
      @clickButton="jumpToIndex"
    )
    footer-common.footer_bar(
      v-if="routerName !== 'pay' && (order.paymentStatus === 1) && !isCounterPay"
      :text="orderText"
      @clickButton="jumpToIndex"
    )
    footer-common.footer_bar(
      v-if="routerName !== 'pay' && (order.paymentStatus !== 1) && !isCounterPay"
      :text="payText"
      @clickButton="payPrePaidOrder"
    )
    bottom-popup-dialog(
      v-model="showDialog"
      :dialog-height="dialogHeight"
      :show-popup-loading="showPopupLoading"
      @changeShow="closeDialog"
    )
      template(v-slot:popup-dialog)
        dialog-content(
          :img-src="logoImgSrc"
          :show-sign-up-page="showSignUpPage"
          :marketing-consent-message="marketingConsentMessage"
          @closeDialog="closeDialog"
          @signUp="signUp"
        )

    marketing-dialog(
      v-model="showSurveys"
      :key="marketingCampaignsKey"
      :round="false"
      @closeDialog="closeMarketingDialog"
    )
      template(v-slot:popup-dialog)
        marketing-campaigns(
          ref="marketingCampaigns"
          :img-src="logoImgSrc"
          :marketing-consent-message="marketingConsentMessage"
          :showSurveys="showSurveys"
          :data="campaignsList"
          :isCampaigns="isCampaigns"
          :orderId="orderId"
          :isDisableButton="isDisableMarketingCampaignsButton"
          @closeDialog="showSurveys = false"
          @signUp="signUp(false)"
        )

    mask-manage-tab(
      :showMask.sync="showManageTabDialog"
    )

</template>

<script>
import Vue from 'vue'
import Component, { mixins } from 'vue-class-component'
import mixin from '@/utils/mixin'
import { getOrder, getUser, updateUser } from '@/api/product'
import { getCurrencySymbol, getSymbolPosition, formatDecimalNumber } from '@/utils/currency'
import { t, tParams } from '@/utils/language'
import { surchargeName } from '@/utils/surcharge'
import { sanitizeRichText } from '@/utils/richtext/sanitizeRichText'
import { richTextHasContent } from '@/utils/richtext/richTextContent'
import { hasStoreOrderNumbers, storeOrderNo, shortOrderNo } from '@/views/venue-sub-group/storeOrderNumbers'
import { mapState } from 'vuex'
import Items from 'views/pay/component/Items'
import Num from 'views/pay/component/Num'
import DownLoadTax from 'views/pay/component/DownLoadTax'
import DialogContent from 'views/pay/component/DialogContent'
import dayjs from 'dayjs'
import {
  customReadyTab,
} from 'utils/message'
import MaskManageTab from 'components/MaskManageTab'
import Collapse from 'components/Collapse'
import MarketingCampaigns from 'views/pay/component/MarketingCampaigns'
import MarketingDialog from 'views/pay/component/MarketingDialog'
import {
  MessageDialog
} from '@/plugins/createApi'
import { trackFunnelEvent } from 'utils/funnelTracking'
import { NO_INPUT_TABLE_NUMBER } from 'utils/constants'

@Component({
  filters: {
    // @return {Number} Format the money and keep two decimal places
    // @return {Number} 格式化钱数，保留两位小数
    fix(val) {
      return Number(val) ? formatDecimalNumber(val) : 0
    },
  },

  components: {
    Items,
    Num,
    DownLoadTax,
    Collapse,
    DialogContent,
    MaskManageTab,
    MarketingCampaigns,
    MarketingDialog
  },

  props: {
    orderId: [String, Number],
    venueSubGroupId: String,
  },

  computed: {
    ...mapState(['venueId', 'paymentInfo', 'id', 'isFromOrderHistoryToOrderDetail']),
    ...mapState({
      isOnline: state => state.app.isOnline,
      venueAddress: state => state.venueHome.pickupSettings && state.venueHome.pickupSettings.pickupAddress && state.venueHome.pickupSettings.pickupAddress !== '' ? state.venueHome.pickupSettings.pickupAddress : state.venueHome.address,
      venueGroupId: state => state.venueHome.venueGroupId,
      routerInfo: state => state.venueHome.routerInfo,
      postWidgetSettings: state => state.venueHome.postWidgetSettings,
      // email: state => state.venueHome.email,
      phone: state => state.venueHome.phone,
      customMessageSettings: state => state.venueHome.customMessageSettings,
    }),

    currencySymbol() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getCurrencySymbol()
    },

    symbolPosition() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getSymbolPosition()
    },

    email() { return 'test@mondoconnex.com' },

    /**
     * @returns {String} Estimated delivery time
     */
    /**
     * @returns {String} 预计送达时间
     */
    preOrderTimeSettings() {
      const { details } = this.order
      const preOrderTimeSettings = details.preOrderTimeSettings
      // Estimated time of third-party delivery
      // 第三方配送的预计时间
      let deliveryTime
      if (details?.deliveryInfo) deliveryTime = this._filterThirdPartyTime(details?.deliveryInfo, 'deliveryTime')
      if (deliveryTime && details.orderType === 'delivery' && details?.deliveryInfo?.deliveryPartner && details?.deliveryInfo?.deliveryPartner !== 'local') {
        return dayjs(deliveryTime).tz().format('DD/MM/YYYY, HH:mm')
      }
      return dayjs(preOrderTimeSettings).format('DD/MM/YYYY, HH:mm')
    },

    // @return {Number} Discount amount
    // @return {Number} 折扣金额
    discountAmount() {
      let discountAmount = 0
      const spDiscounts = this.order.spDiscounts
      if (spDiscounts && spDiscounts.length) {
        spDiscounts.forEach(item => discountAmount += Number(item.totalAmount))
      }
      return discountAmount
    },

    // @return {Boolean} Display discount amount
    // @return {Boolean} 是否显示折扣金额
    showDiscounts() {
      if (this.order.id && this.order.details.discounts) {
        const amount = parseFloat(this.order.details.discounts.amount)
        if (amount) return true
      }
      return false
    },

    // @return {Boolean} Show tip amount
    // @return {Boolean} 是否显示小费金额
    showTipping() {
      return this.order.id && this.order.details.enableTip
    },

    // @return {Boolean} Whether it is a post payment order
    // @return {Boolean} 是否是后付款类型订单
    isPostPaid() {
      return this.order.type === 2
    },

    discountRate() {
      if (this.order.id) {
        if (this.order.details.discounts) {
          return formatDecimalNumber(parseFloat(this.order.details.discounts.rate))
        } else {
          return formatDecimalNumber(0)
        }
      } else {
        return formatDecimalNumber(0)
      }
    },

    customerMerchantFee() {
      if (this.order.id) {
        return this.order.details.customerMerchantFee
      } else {
        return 0
      }
    },

    getOrderEmail() {
      if (this.order.id) {
        if (this.order.details && this.order.details.userInfo) {
          return this.order.details.userInfo.email
        } else {
          return ''
        }
      } else {
        return ''
      }
    },

    isCounterPay() {
      return this.order.details ? this.order.details.payAtCounter : false
    },

    orderMoreText() {
      const VENUE_IS_OPEN_TEXT = t('order_more', 'ORDER MORE')
      const VENUE_IS_CLOSE_TEXT = t('view_menu', 'VIEW MENU')
      return this.isVenueOpenTime ? VENUE_IS_OPEN_TEXT : VENUE_IS_CLOSE_TEXT
    },

    isRateDiscount() {
      const PERCENTAGE_TYPE = 'percentage'
      return this.order.details.discounts?.rateType === PERCENTAGE_TYPE
    },

    isTabPay() {
      return false
    },

    /**
     * Solve the problem that order.createdAtString displays Invalid date after formatting and filter out the creation order time that displays the correct time format
     * @return createdAtString {String} Order creation time
     */
    /**
     * 解决 order.createdAtString 格式化以后显示 Invalid date, 筛选出显示正确时间格式的创建订单时间
     * @return createdAtString {String} 订单创建时间
     */
    createdOrderTime() {
      const createdAtString = dayjs(this.order.createdAtString).format('DD MMMM, YYYY')
      const createdAt = dayjs.unix(this.order.createdAt).format('DD MMMM, YYYY')
      return ' ' + (createdAtString === 'Invalid Date' ? createdAt : createdAtString)
    },

    surchargeHead() {
      const WEEKDAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
      const d = this.order.details
      // createdAtString is already venue-local — do NOT apply .tz()
      const fallbackWeekDay = this.order.createdAtString
        ? WEEKDAYS[dayjs(this.order.createdAtString).day()]
        : undefined
      if (d && d.surchargeAmount && d.surchargeSettings && d.surchargeSettings.type === 'date') {
        return surchargeName({ type: 'date', group: d.surchargeSettings.settings && d.surchargeSettings.settings.group, settings: d.surchargeSettings })
      }
      if (d && d.surchargeAmount && d.surchargeSettings && d.surchargeSettings.type === 'weekly') {
        return surchargeName({ type: 'weekly', weekDay: d.surchargeSettings.weekDay || fallbackWeekDay, settings: d.surchargeSettings })
      }
      if (fallbackWeekDay) {
        return surchargeName({ type: 'weekly', weekDay: fallbackWeekDay })
      }
      return surchargeName({ type: 'date' })
    },

    // @return {Boolean} 是否显示外卖信息提示文案
    showOnlineInfo() {
      const orderType = this.order.details.orderType
      const routerName = this.routerName
      return (orderType === 'delivery' && routerName === 'pay') || (orderType === 'pickup' && routerName === 'pay')
    },

    /**
     * @returns {String} Allergy prompt copy
     */
    /**
     * @returns {String} 过敏提示文案
     */
    alcoholText() {
      let text = ''
      let type = ''
      if (this.order) {
        const {
          details,
          menuType
        } = this.order
        // Get the current order type according to the order information
        // 根据订单信息，获取当前的订单类型
        if (details.orderType === 'dine-in' && details.table) {
          type = 'table'
        } else if (details.orderType === 'dine-in' && !details.table && menuType === 'normal') {
          type = 'counter'
        } else if (details.orderType === 'takeaway' && menuType === 'online') {
          type = 'takeaway'
        } else if (details.orderType === 'pickup') {
          type = 'pickup'
        } else if (details.orderType === 'delivery') type = 'delivery'
      }
      // View the corresponding copy information according to the order type
      // 根据订单类型，查看对应的文案信息
      if (type && this.customMessageSettings?.confirmation) {
        const message = this.customMessageSettings.confirmation[type]?.message ?? ''
        if (this.customMessageSettings.confirmation[type]?.enable) text = message.trim() ? message : ''
      }
      return text
    },

    errorOrderText() {
      if (this.venueGroupId === '4df096df-8a68-4899-91ed-2dd43ab672c3') {
        // minor message
        return t('order_problem_contact_staff', 'There\'s a problem with your order. Please contact staff with this message.')
      } else {
        return t('order_problem_see_staff', 'There\'s a problem with your order. Please see staff at the counter with this message.')
      }
    },
    orderStatusUrl() {
      return `/vgs/${this.venueSubGroupId}/order-status/${this.order.id}`
    }
  },

  watch: {
    $route(val) {
      this.routerName = val.name
    },

    isMarketing(val) {
      // TODO: isMarketing do not go into the url by normal processing
      if (val) { // This level of judgment basically determines whether the segment is entering the page for the first time   // 这层判断基本是判断是否是第一次进入页面
        const url = window.location.href.replace('&isMarketing=1', '') // After the judgment, the url is remade, and the isMarketing parameter is changed after the page is refreshed   // 判断之后就重置 url，让页面刷新之后更改 isMarketing 参数
        window.history.pushState({}, 0, url) // Do not jump to rewrite url   // 不跳转重写 url
        const time = (Number(this.postWidgetSettings?.displayWaitingTime ?? 1.5)) * 1000
        // Delay the pop-up window display, and determine the type of pop-up window display for email marketing, advertising and answering questions according to the situation
        // 延迟显示弹窗，根据情况决定显示邮件营销、广告、答题弹窗类型
        setTimeout(() => {
          switch (this.isCampaigns) {
            case 0:
              this.showSurveys = false
              this.showDialog = false
              break

            case 1:
            case 3:
              this.showSurveys = true
              this.showDialog = false
              break

            case 2:
              this.showSurveys = false
              this.showDialog = true
              break
          }
        }, time)
      }
    }
  },

})

class OrderDetail extends mixins(mixin) {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  tParams(key, fallback, params) { return tParams(key, fallback, params) }

  isCampaigns = 0
  isMarketing = false
  showSurveys = false
  showManageTabDialog = false
  // @todo constent tippingPercent
  tippingPercent = 0.1
  showPopupLoading = false
  addedMarket = true
  showSignUpPage = true
  timer = null
  dialogHeight = 43
  showDialog = false
  total = 998
  orderText = t('place_another_order', 'PLACE ANOTHER ORDER')
  counterOrderText = t('order_more', 'ORDER MORE')
  fromOrderHistory = false
  discoutPrice = 22
  discountPercentage = 0.012
  surchargePrice = 889
  payText = t('pay_order', 'PAY ORDER')
  routerName = ''
  order = {}
  orderNo = ''
  setTimeout = null
  campaignsList = []
  isDisableMarketingCampaignsButton = false // Whether to disable the button of marketing campaign   // 是否禁用营销活动的按钮
  marketingCampaignsKey = 0
  tempCollapseIndex = 0

  async created() {
    // Manage the isIframeCondition added in the background to distinguish the iframe environment
    // 管理后台添加的 isIframeCondition 来区别 iframe 环境
    this.isIframeCondition = this.$route.query.isIframeCondition
    // If it is iframe
    // 如果是 iframe
    if (this.isIframeCondition) {
      const self = this
      window.addEventListener('message', async function (e) {
        if (e.data.name === 'dataToMobileIframe') {
          if (e.data.data) {
            self.campaignsList = [e.data.data]
            self.isDisableMarketingCampaignsButton = true
            self.showSurveys = true
            self.marketingCampaignsKey++
          }
        }
      })
    } else {
      this.$store.commit('showLoading')
      await this.__checkVenueSubgroupOpenTime()
      this.routerName = this.$route.name
      this.orderNo = this.$route.query.orderNo
      this.fromOrderHistory = this.$route.query?.orderHistory === 'true' ?? false
      await this._updateOrder()
      this.controlShowDialog()
      this._openTabReadyDialog()
      // The sequence of the following codes should be at the end, otherwise there will be time difference in the delayed pop-up
      // 下面代码的顺序要在最后，不然延迟显示弹窗会有时差
      await this.checkAddedMarket()
      this.$store.commit('closeLoading')
      // When entering this page, clear the activeIndex to prevent the problem that the scroll bar does not top after returning to the product list page
      // 进入本页面时，清空 activeIndex，防止回到商品列表页后，滚动条没有置顶的问题
      sessionStorage.removeItem('activeIndex')
    }

    this._setupOrderButton()

    const clearCart = this.$route.query.clearCart ?? false
    if (clearCart === '1') {
      // clear cart
      this.$store.commit('clearProductList')
      // 与 `views/pay/index.vue` 同一处：清车不清折扣会让下一单算出负数总价。
      // 这页的折扣显示读的是 `this.order.spDiscounts`（接口下发的那一单），不是 store。
      this.$store.commit('clearDiscounts')
    }

    if (this.$openreplayTracker) this.$openreplayTracker.event('purchase')
    trackFunnelEvent('purchase')
    if (this.$gtag) {
      this.$gtag.event('purchase', {
        event_category: 'purchase_journey',
        event_label: 'Finish Purchase',
      })
    }
  }

  mounted() {
    this._sendMsgToBacken()
  }

  _setupOrderButton() {
    if (process.env.VUE_APP_ENV !== 'production' && this.venueId === 'f1bb777a-51f6-4298-b81c-2e4a586a180b' && this.fromOrderHistory) {
      this.counterOrderText = 'RE ORDER'
      this.orderText = 'RE ORDER'
    }
  }

  _openTabReadyDialog() {
    const { isTabReady } = this.$route.query
    if (isTabReady) {
      const self = this
      this.$createTabMessageDialog({
        $props: customReadyTab,
        $events: {
          click() {
            self.showManageTabDialog = true
          }
        }
      }).show()
    }
  }

  beforeDestroy() {
    clearTimeout(this.setTimeout)
  }

  async checkAddedMarket() {
    const userId = localStorage.getItem('userId')
    const notificationKey = localStorage.getItem('notificationKey') || ''
    if (userId) {
      const res = await getUser({
        id: userId,
        notificationKey: notificationKey,
        venueId: this.venueId,
        venueSubGroupId: this.venueSubGroupId,
        orderId: this.order ? this.order.id : '',
      }).catch(error => {
        console.log(error)
        this.$store.commit('closeLoading')
      })
      const joinMarketingList = res.joinMarketingList || []
      this.addedMarket = joinMarketingList.includes(this.venueId)
      this.campaignsList = res.campaigns
      this.isCampaigns = this._showDialogType(res.campaigns)
    } else {
      // if there is not userId, then unShow the dialog
      this.addedMarket = true
    }
    this.isMarketing = Number(this.$route.query.isMarketing) || false
  }

  // Close the pop-up window of marketing
  // 关闭营销的弹窗
  closeMarketingDialog() {
    this.$refs.marketingCampaigns._closeAnswerCampaign()
    this.showSurveys = false
  }

  closeDialog() {
    this.showDialog = false
    this._setPopupOnceTime()
  }

  _setPopupOnceTime() {
    const nowTime = dayjs.tz().format('YYYY-MM-DD')
    const { venueId } = this
    this.$store.commit('signUpDialogOnceTime/SET_SIGN_UP_POPUP_ONCE_TIME', {
      nowTime,
      venueId
    })
  }

  /**
   * Confirm to join email marketing
   * @param isShow {Boolean} Whether the secondary pop-up window is displayed
   */
  /**
   * 确定加入邮件营销
   * @param isShow {Boolean} 是否显示二级弹窗
   */
  async signUp(isShow = true) {
    console.log('async')
    this.showPopupLoading = isShow
    await this.addUserToMarket()
    this.closeSignUpPage()
  }

  closeSignUpPage() {
    this.showPopupLoading = false
    this.showSignUpPage = false
  }

  async addUserToMarket() {
    const res = await updateUser({
      id: localStorage.userId,
      joinMarketingConsent: true,
      venueId: this.venueId
    }).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    console.log(res)
  }

  controlShowDialog() {
    // clearTimeout for aviod to active timeout more than once
    const isPostHasPaidOrder = this.isPostPaid && (this.routerName === 'my-order') && !this.isCounterPay
    const isPreHasPaidOrder = !this.isPostPaid
    if (isPostHasPaidOrder || isPreHasPaidOrder) {
      const enableMarketingConsent = this.enableMarketingConsent
      const notAddedMarketYet = !this.addedMarket
      const notTodayPopupOnce = !this._isTodayPopupOnce()
      const isAutoShowDialog = !this.isFromOrderHistoryToOrderDetail
      console.log(enableMarketingConsent, notAddedMarketYet, notTodayPopupOnce, isAutoShowDialog)
    }
  }

  _sendMsgToBacken() {
    // Iframe sends data to the father to inform the caller that the page has been loaded
    // iframe 发送数据给父亲, 方便告诉调用者，页面已加载完毕
    window.top.postMessage({
      name: 'mounted',
      data: 'mounted',
    }, '*')
  }

  /**
   * Judge the type of pop-up window to be displayed when returning
   * @param surveyList {Array} Feedback List
   * @returns {Numer} Pop up window type 0: Do not display  1: Marketing+feedback  2: Marketing  3: feedback
   */
  /**
   * 判断返回要显示的弹窗类型
   * @param surveyList {Array} 反馈列表
   * @returns {Numer} 弹窗类型 0: 不显示  1: 营销+反馈  2: 营销  3: 反馈
   */
  _showDialogType(surveyList = []) {
    const isPostHasPaidOrder = this.isPostPaid && (this.routerName === 'my-order') && !this.isCounterPay
    const isPreHasPaidOrder = !this.isPostPaid
    if (!isPostHasPaidOrder && !isPreHasPaidOrder) return 0
    const enableMarketingConsent = this.enableMarketingConsent
    const notAddedMarketYet = !this.addedMarket
    const notTodayPopupOnce = !this._isTodayPopupOnce()
    const isAutoShowDialog = !this.isFromOrderHistoryToOrderDetail
    const showMarketingDialog = enableMarketingConsent && notAddedMarketYet && notTodayPopupOnce && isAutoShowDialog
    const showSurveyDialog = isAutoShowDialog && surveyList?.length
    if (showMarketingDialog && showSurveyDialog) return 1
    if (showMarketingDialog && !showSurveyDialog) return 2
    if (!showMarketingDialog && showSurveyDialog) return 3
    return 0
  }

  _isTodayPopupOnce() {
    const nowTime = dayjs.tz().format('YYYY-MM-DD')
    const lastTime = this._getPopupTime()
    return nowTime === lastTime
  }

  _getPopupTime() {
    this.$store.commit('signUpDialogOnceTime/GET_SIGN_UP_POPUP_ONCE_TIME')
    return this.$store.state.signUpDialogOnceTime.popupTime[this.venueId] ?? ''
  }

  payPrePaidOrder() {
    // jump to payment page
    // jump to payment 页面
    // this.orderId is from prop, that is, from $route.params.orderId
    // this.orderId 是来自于 prop 也就是从 $route.params.orderId 拿到的

    // clearTimeout for canceling the showDialog
    clearTimeout(this.timer)
    this.jumpToPayment()
  }

  jumpToIndex() {
    // clearTimeout for canceling the showDialog
    clearTimeout(this.timer)
    const isPass = this._checkEnvironmentalData()
    if (!isPass) return
    // 仅使用 routerInfo.number（来自路由 params 的真实桌号），不使用 query 中的 tableNumber 来决定导航路径
    const tableNumber = this.routerInfo.number

    if (tableNumber) {
      this.$router.push(`/vgs/${this.venueSubGroupId}/t/${tableNumber}`)
    } else {
      if (this.routerInfo.noTable) {
        this.$router.push(`/vgs/${this.venueSubGroupId}/t/${this.order.details.table}`)
      } else {
        this.$router.push(`/vgs/${this.venueSubGroupId}/`)
      }
    }
  }

  jumpToPayment() {
    const isPass = this._checkEnvironmentalData()
    if (!isPass) return
    this.$router.push({
      path: `/vgs/${this.venueSubGroupId}/payment`,
      query: {
        orderNo: this.order.orderNo,
        orderId: this.order.id
      }
    })
  }

  /**
   * 检查环境数据
   * @returns {Boolean} 是否检查成功
   */
  _checkEnvironmentalData() {
    // 是否通过检查
    let isPass = true
    const isTakeaway = this.$route.path.includes('/v/o/') || this.$route.path.includes('/online/')
    // 'n-t' 是无桌号入口（如 vgs 模式）的占位符，不是真实桌号，不做桌号校验
    // query 参数重复时 vue-router 会解析成数组，取第一个值
    const rawTableNumber = this.$route.query.tableNumber
    const queryTableNumber = Array.isArray(rawTableNumber) ? rawTableNumber[0] : rawTableNumber
    if (queryTableNumber && queryTableNumber !== NO_INPUT_TABLE_NUMBER) { // table 环境
      const table = this.$store?.state?.details?.table
      // 若不存在 tbale 数据，弹窗提示
      if (!table) {
        isPass = false
      }
    } else if (isTakeaway && this.$route.query.portal === 'true' && (this.$route.query.ta === null || this.$route.query.ta === undefined)) { // takeaway 环境
      if (this.$store?.state?.details?.orderType !== 'takeaway') {
        isPass = false
      }
    } else if (this.$route.query.portal === 'true') { // counter 环境
      if (this.$store?.state?.details?.orderType !== 'dine-in') {
        isPass = false
      }
    }
    // 检查不通过时，弹窗提醒
    if (!isPass) {
      MessageDialog.$create({
        content: t('session_expired', 'Your session has expired. Please scan the QR code to start your new order.')
      }).show()
    }
    return isPass
  }

  // 每 10s 获取订单信息
  async _updateOrder() {
    await this._getOrder()
    this.setTimeout = setTimeout(_ => {
      this._updateOrder()
    }, 10000)
  }

  async _postOrder() {
    try {
      const res = await getOrder({
        id: this.orderId,
        venueSubGroupId: this.venueSubGroupId
      })
      return res
    } catch {
      this.$store.commit('closeLoading')
    }
  }

  async _getOrder() {
    const res = await this._postOrder()
    this.order = {
      ...res,
      itemList: res.itemList
    }
    this.saveIspostPaid()
    this.saveIsCounterPay()
  }

  saveIspostPaid() {
    const res = this.order.type === 2
    this.$store.commit('saveIspostPaid', res)
  }

  saveIsCounterPay() {
    const res = this.order.details.payAtCounter
    this.$store.commit('saveIsCounterPay', res)
  }

  /**
   * Time for screening third-party delivery
   * @param {Object} deliveryInfo Third party takeout information
   * @param {String} type Which type of time to obtain
   * @returns {String} Filtered time
   */
  /**
   * 筛选第三方外卖提供的时间
   * @param {Object} deliveryInfo 第三方外卖信息
   * @param {String} type 需要获取哪个类型的时间
   * @returns {String} 筛选过的时间
   */
  _filterThirdPartyTime(deliveryInfo, type) {
    let time = ''
    // The following filters are used to obtain the latest time returned by the third party
    // 以下筛选为了取第三方返回的最新时间
    const events = deliveryInfo?.extra?.events
    // Decide which value to take according to the type of parameter passed
    // 根据传参的类型，决定取哪个值
    let key = ''
    if (type === 'deliveryTime') {
      key = 'plannedDropoffTime'
    } else if (type === 'pickupTime') key = 'plannedPickupTime'
    // Take the last time in the array returned by the third party. If the last time is not available, find the next to last, and so on
    // 取第三方返回数组中的最后一个时间，若最后一个没有，再找倒数第二个，以此类推
    time = this._.find(this._.reverse(events), item => item?.data[key] ?? false)

    return time ? time.data[key] : deliveryInfo[type]
  }

  checkPosStatus(venueId) {
    return this.order.orderList?.[venueId]?.[0]?.details?.posStatus === 2
  }

  getOrderCollectionInfo(venueId) {
    return this.order.orderList?.[venueId]?.[0]?.venueCollectionMessage ?? ''
  }

  // 取餐说明由管理端富文本编辑器产出,可能带 HTML 标签(<p>/&nbsp; 等)。
  // 净化后 v-html 渲染,避免把标签当纯文本原样显示给顾客,同时挡住存储型 XSS。
  renderRichText(html) {
    return sanitizeRichText(html)
  }

  // 富文本说明判空:空 / 只剩 <p></p>、<p>&nbsp;</p> 之类残留时整段不渲染。
  hasRichContent(html) {
    return richTextHasContent(html)
  }

  // 跨组 sub group 门控:任一店展示的成员号 ≠ 父号 → 整单每店展示自己的取餐号。
  // type=0 恒 false(后端父/子同号不变量),顾客端零变化。
  get hasStoreNumbers() {
    return hasStoreOrderNumbers(this.order)
  }

  // 某店的短取餐号(从 orderList 交叉读,取 '_' 后末段);缺失返回 ''。
  storeNo(venueId) {
    return shortOrderNo(storeOrderNo(this.order, venueId))
  }
}

export default OrderDetail
</script>
